/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataLeakSeverityEnum } from './DataLeakSeverityEnum';
import {
    DataLeakSeverityEnumFromJSON,
    DataLeakSeverityEnumFromJSONTyped,
    DataLeakSeverityEnumToJSON,
    DataLeakSeverityEnumToJSONTyped,
} from './DataLeakSeverityEnum';
import type { LeakTypeEnum } from './LeakTypeEnum';
import {
    LeakTypeEnumFromJSON,
    LeakTypeEnumFromJSONTyped,
    LeakTypeEnumToJSON,
    LeakTypeEnumToJSONTyped,
} from './LeakTypeEnum';
import type { DataLeakStatusEnum } from './DataLeakStatusEnum';
import {
    DataLeakStatusEnumFromJSON,
    DataLeakStatusEnumFromJSONTyped,
    DataLeakStatusEnumToJSON,
    DataLeakStatusEnumToJSONTyped,
} from './DataLeakStatusEnum';

/**
 * 
 * @export
 * @interface PatchedDataLeak
 */
export interface PatchedDataLeak {
    /**
     * 
     * @type {number}
     * @memberof PatchedDataLeak
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedDataLeak
     */
    snippet?: string;
    /**
     * 
     * @type {LeakTypeEnum}
     * @memberof PatchedDataLeak
     */
    leakType?: LeakTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedDataLeak
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedDataLeak
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedDataLeak
     */
    sourceLink?: string | null;
    /**
     * 
     * @type {DataLeakSeverityEnum}
     * @memberof PatchedDataLeak
     */
    severity?: DataLeakSeverityEnum;
    /**
     * 
     * @type {DataLeakStatusEnum}
     * @memberof PatchedDataLeak
     */
    status?: DataLeakStatusEnum;
    /**
     * 
     * @type {any}
     * @memberof PatchedDataLeak
     */
    otherInfo?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedDataLeak
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedDataLeak
     */
    readonly updatedAt?: Date;
}



/**
 * Check if a given object implements the PatchedDataLeak interface.
 */
export function instanceOfPatchedDataLeak(value: object): value is PatchedDataLeak {
    return true;
}

export function PatchedDataLeakFromJSON(json: any): PatchedDataLeak {
    return PatchedDataLeakFromJSONTyped(json, false);
}

export function PatchedDataLeakFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedDataLeak {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'snippet': json['snippet'] == null ? undefined : json['snippet'],
        'leakType': json['leak_type'] == null ? undefined : LeakTypeEnumFromJSON(json['leak_type']),
        'category': json['category'] == null ? undefined : json['category'],
        'description': json['description'] == null ? undefined : json['description'],
        'sourceLink': json['source_link'] == null ? undefined : json['source_link'],
        'severity': json['severity'] == null ? undefined : DataLeakSeverityEnumFromJSON(json['severity']),
        'status': json['status'] == null ? undefined : DataLeakStatusEnumFromJSON(json['status']),
        'otherInfo': json['other_info'] == null ? undefined : json['other_info'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedDataLeakToJSON(json: any): PatchedDataLeak {
      return PatchedDataLeakToJSONTyped(json, false);
  }

  export function PatchedDataLeakToJSONTyped(value?: Omit<PatchedDataLeak, 'id'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'snippet': value['snippet'],
        'leak_type': LeakTypeEnumToJSON(value['leakType']),
        'category': value['category'],
        'description': value['description'],
        'source_link': value['sourceLink'],
        'severity': DataLeakSeverityEnumToJSON(value['severity']),
        'status': DataLeakStatusEnumToJSON(value['status']),
        'other_info': value['otherInfo'],
    };
}

